import React from "react";
import Work01 from "./Work01/Work01";

export default () => (
  <Work01/>
);
